import React from "react";
import Header from "./Header";
import { Link, useLocation } from "react-router-dom";
import "../styles/LandingSection.css";

const LandingSection = (props) => {
  const location = useLocation();
  const imageName = props?.data.imageName;
  const title = props?.data.title;
  const breadcrumb = props?.data.breadcrumb || props?.data.breadcrumbs;
  const breadcrumbLinks = props?.data.breadcrumbLinks;
  const backgroundSize = props?.data.backgroundSize;
  const backgroundPosition = props?.data.backgroundPosition;
  const heroHeight = props?.data.heroHeight;
  const backgroundRepeat = props?.data.backgroundRepeat;

  // Breadcrumb mapping for URL segments
  const breadcrumbMap = {
    // Utah at a Glance pages
    'utah-at-a-glance': 'Utah at a Glance',
    'adventure-activities': 'Adventure Activities',
    'charging-stations': 'Utah Charging Stations',
    'utah-housing': 'Utah Housing',
    'utah-counties': 'Utah Counties',
    'demographics': 'Demographics',
    'jobs': 'Jobs',
    'unemployment-rate': 'Unemployment Rate',
    'geothermal': 'Geothermal',
    'airports': 'Airports',
    'mlm': 'MLM',
    'hospital': 'Hospitals',
    'hospitals': 'Hospitals',
    'air-quality': 'Air Quality',
    'zipcode': 'Zip Codes',
    'zipcodes': 'Zip Codes',
    'finance': 'Finance',
    'culture': 'Culture',
    'places-to-visit': 'Places to Visit',
    'agencies': 'Federal Agencies',
    'utah-funfacts': 'Utah Fun Facts',
    'sba-advocacy': 'SBA Advocacy',
    'utah-governor': 'Utah Governor',
    'education-and-intellectual-resources': 'Education and Intellectual Resources',
    'utah-schools': 'Utah Schools',
    'charter-schools': 'Charter Schools',
    'utah-universities': 'Utah Universities',

    // Verticals pages
    'verticals': 'Utah Verticals',
    'manufacturing': 'Manufacturing',
    'information': 'Information',
    'professional-scientific-and-technical-services': 'Professional, Scientific, and Technical Services',
    'food-industry': 'Food Industry',
    'transportation-and-warehousing': 'Transportation and Warehousing',
    'architecture-and-construction': 'Architecture and Construction',
    'construction': 'Construction',
    'aerospace-and-defense': 'Aerospace and Defense'
  };

  // Generate breadcrumb from URL if not provided or incomplete
  const generateBreadcrumbData = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');

    // If we have breadcrumb data from props but it's an array (plural form), convert it to string
    let displayBreadcrumb = breadcrumb;
    if (Array.isArray(breadcrumb)) {
      displayBreadcrumb = breadcrumb.join(' >> ');
    }

    // Don't show breadcrumb for parent pages (only one segment) or home page
    if (pathSegments.length <= 1 && !displayBreadcrumb) return null;

    const breadcrumbParts = [];
    const breadcrumbLinkParts = [];
    let currentPath = '';

    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const displayName = breadcrumbMap[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

      breadcrumbParts.push(displayName);
      if (index < pathSegments.length - 1) {
        breadcrumbLinkParts.push(currentPath);
      }
    });

    // Merge provided data with generated data if necessary
    return {
      breadcrumb: displayBreadcrumb || breadcrumbParts.join(' >> '),
      breadcrumbLinks: breadcrumbLinks || breadcrumbLinkParts
    };
  };

  const renderBreadcrumb = () => {
    const breadcrumbData = generateBreadcrumbData();

    if (!breadcrumbData || !breadcrumbData.breadcrumb) return null;

    const parts = typeof breadcrumbData.breadcrumb === 'string'
      ? breadcrumbData.breadcrumb.split(' >> ')
      : Array.isArray(breadcrumbData.breadcrumb) ? breadcrumbData.breadcrumb : [];

    if (parts.length === 0) return null;

    return (
      <div className="breadcrumb" style={{
        fontSize: '14px',
        marginBottom: '10px',
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        position: 'relative',
        zIndex: 1001,
        pointerEvents: 'auto'
      }}>
        {parts.map((part, index) => (
          <span key={index} style={{ display: 'flex', alignItems: 'center' }}>
            {index < parts.length - 1 && breadcrumbData.breadcrumbLinks && breadcrumbData.breadcrumbLinks[index] ? (
              <Link
                to={breadcrumbData.breadcrumbLinks[index]}
                className="breadcrumb-link"
                style={{
                  color: 'white',
                  textDecoration: 'underline',
                  textShadow: '2px 2px 4px rgba(0,0,0,1)'
                }}
              >
                {part}
              </Link>
            ) : (
              <span style={{ textShadow: '2px 2px 4px rgba(0,0,0,1)' }}>
                {part}
              </span>
            )}
            {index < parts.length - 1 && <span style={{ margin: '0 8px', textShadow: '2px 2px 4px rgba(0,0,0,1)' }}>{' >> '}</span>}
          </span>
        ))}
      </div>
    );
  };

  return (
    <>
      <div
        className="landing"
        style={{
          backgroundImage: `url(/img/landing-webp/${imageName})`,
          backgroundSize: backgroundSize || 'cover',
          backgroundPosition: backgroundPosition || 'center center',
          backgroundRepeat: backgroundRepeat || 'no-repeat',
          height: heroHeight || undefined,
          width: '100%',
          minWidth: '100%',
          maxWidth: '100%'
        }}
      >
        <div className={props.data.visible ? "landing-overlay" : null}>
          <Header />
          <div className="landing_content "
            style={{ textShadow: '2px 2px 4px rgba(0,0,0,1)' }}>
            {renderBreadcrumb()}
            <h1>{title}</h1>
            <p>[SCROLL TO SEE]</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingSection;
